<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="26%" @open="addOpen" :close-on-click-modal="false">
    <el-select v-model="formData.labels" multiple filterable allow-create placeholder="请选择标签" style="width: 100%;">
      <el-option label="请选择标签" :value="0"></el-option>
      <el-option v-for="item in labelList" :key="item.id" :label="item.title" :value="item.id">
      </el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'mail_label_add',
  props: [
    'visible', 'id', 'labelList', 'labels', 'isMulti'
  ],
  data () {
    return {
      title: '添加标签',
      formData: {
        sub_id: 0,
        labels: []
      }
    }
  },
  methods: {
    closeDialog () {
      this.formData.sub_id = 0
      this.formData.labels = []
      this.$emit('closeDialog')
    },
    addConfirm () {
      if (this.isMulti) {
        this.$emit('multiAdd', this.formData)
      } else {
        this.$emit('add', this.formData)
      }
    },
    addOpen () {
      this.formData.sub_id = this.id
      this.formData.labels = this.labels
      if (this.isMulti) {
        this.title = '批量添加标签'
      } else {
        this.title = '添加标签'
      }
    }
  }
}
</script>

<style scoped>
</style>
